import React from 'react';

export default function DashboardDateFilter({
  startDate,
  endDate,
  errorMessage,
  onStartDateChange,
  onEndDateChange,
  onApply,
  onOpenAlarms,
  secondaryActionAriaLabel = 'Root Cause Alarms',
  secondaryActionContent = '🚨',
  summaryContent = null,
  styles,
  t,
}) {
  return (
    <div className={styles.dateFilterSection}>
      <div className={styles.systemHealthContainer}>
        <div className={styles.systemHealth}>
          <div className={styles.greenLight}></div>
          <p className={styles.systemHealthText}>{t('System Health')}: <strong>{t('Healthy')}</strong></p>
        </div>
        <div className={styles.currentDateTime}>
          <p className={styles.systemHealthText}>{t('Current Date & Time')}: <strong>{new Date().toLocaleString()}</strong></p>
        </div>
      </div>

      <h3 className={styles.dateFilterTitle}>{t('Date Filter')}:</h3>
      <div className={styles.dateFilterContent}>
        <div className={styles.inlineFilter}>
          <div className={styles.filterItem}>
            <label htmlFor="startDate" className={styles.filterLabel}>{t('Start Date')}:</label>
            <input
              id="startDate"
              type="date"
              value={startDate ? startDate.toISOString().split('T')[0] : ''}
              onChange={(event) => onStartDateChange(event.target.value ? new Date(event.target.value) : null)}
              className={styles.dateInput}
            />
          </div>
          <div className={styles.filterItem}>
            <label htmlFor="endDate" className={styles.filterLabel}>{t('End Date')}:</label>
            <input
              id="endDate"
              type="date"
              value={endDate ? endDate.toISOString().split('T')[0] : ''}
              onChange={(event) => onEndDateChange(event.target.value ? new Date(event.target.value) : null)}
              className={styles.dateInput}
            />
          </div>
          <button onClick={onApply} className={styles.applyButton}>{t('Apply')}</button>
        </div>
        {typeof onOpenAlarms === 'function' ? (
          <button
            className={styles.alarmButton}
            onClick={onOpenAlarms}
            aria-label={secondaryActionAriaLabel}
          >
            {secondaryActionContent}
          </button>
        ) : null}
      </div>

      {errorMessage && (
        <div className={styles.errorMessage}>
          <p>{errorMessage}</p>
        </div>
      )}

      {summaryContent && (
        <div className={styles.dateFilterSummaryRow}>
          {summaryContent}
        </div>
      )}
    </div>
  );
}
